import React from 'react';
interface Traveller {
  name: string;
  dateOfBirth: string;
  passportNo: string;
  expiry: string;
  nationality: string;
  mealNotes?: string;
  visa?: string;
}
interface RoomGroup {
  roomNumber?: string;
  roomType?: string;
  travellers: Traveller[];
}
interface PaxStatementTravellersProps {
  rooms: RoomGroup[];
}
export function PaxStatementTravellers({
  rooms
}: PaxStatementTravellersProps) {
  const hasRoomNumbers = rooms.some(room => room.roomNumber);
  return <div className="mb-6" data-id="element-817">
      <h3 className="text-sm font-bold text-neutral-900 uppercase tracking-wide mb-4 pb-2 border-b-2 border-neutral-300" data-id="element-818">
        Travellers
      </h3>

      {hasRoomNumbers ?
    // Show grouped by room when room numbers exist
    rooms.map((room, roomIndex) => <div key={roomIndex} className="mb-5" data-id="element-819">
            {/* Room Label */}
            <div className="bg-neutral-100 border border-neutral-200 rounded-t-lg px-4 py-2" data-id="element-820">
              <p className="text-xs font-bold text-neutral-900" data-id="element-821">
                {room.roomNumber} ({room.roomType})
              </p>
            </div>

            {/* Travellers Table */}
            <div className="border border-t-0 border-neutral-200 rounded-b-lg overflow-hidden" data-id="element-822">
              <table className="w-full text-xs" data-id="element-823">
                <thead className="bg-neutral-50 border-b border-neutral-200" data-id="element-824">
                  <tr data-id="element-825">
                    <th className="text-left font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-826">
                      Traveller Name
                    </th>
                    <th className="text-left font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-827">
                      Date of Birth
                    </th>
                    <th className="text-left font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-828">
                      Passport No.
                    </th>
                    <th className="text-left font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-829">
                      Expiry
                    </th>
                    <th className="text-left font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-830">
                      Nationality
                    </th>
                    <th className="text-left font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-831">
                      Meal / Notes
                    </th>
                    <th className="text-left font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-832">
                      Visa
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-833">
                  {room.travellers.map((traveller, tIndex) => <tr key={tIndex} className="border-b border-neutral-200 last:border-b-0" data-id="element-834">
                      <td className="px-3 py-2.5 font-semibold text-neutral-900" data-id="element-835">
                        {traveller.name}
                      </td>
                      <td className="px-3 py-2.5 text-neutral-900" data-id="element-836">
                        {traveller.dateOfBirth}
                      </td>
                      <td className="px-3 py-2.5 text-neutral-900" data-id="element-837">
                        {traveller.passportNo}
                      </td>
                      <td className="px-3 py-2.5 text-neutral-900" data-id="element-838">
                        {traveller.expiry}
                      </td>
                      <td className="px-3 py-2.5 text-neutral-900" data-id="element-839">
                        {traveller.nationality}
                      </td>
                      <td className="px-3 py-2.5 text-neutral-700" data-id="element-840">
                        {traveller.mealNotes || '—'}
                      </td>
                      <td className="px-3 py-2.5 text-neutral-900" data-id="element-841">
                        {traveller.visa || '—'}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>) :
    // Show single table without room grouping when no room numbers
    <div className="border border-neutral-200 rounded-lg overflow-hidden" data-id="element-842">
          <table className="w-full text-xs" data-id="element-843">
            <thead className="bg-neutral-50 border-b border-neutral-200" data-id="element-844">
              <tr data-id="element-845">
                <th className="text-left font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-846">
                  Traveller Name
                </th>
                <th className="text-left font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-847">
                  Date of Birth
                </th>
                <th className="text-left font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-848">
                  Passport No.
                </th>
                <th className="text-left font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-849">
                  Expiry
                </th>
                <th className="text-left font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-850">
                  Nationality
                </th>
                <th className="text-left font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-851">
                  Meal / Notes
                </th>
                <th className="text-left font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-852">
                  Visa
                </th>
              </tr>
            </thead>
            <tbody data-id="element-853">
              {rooms.flatMap(room => room.travellers).map((traveller, index) => <tr key={index} className="border-b border-neutral-200 last:border-b-0" data-id="element-854">
                    <td className="px-3 py-2.5 font-semibold text-neutral-900" data-id="element-855">
                      {traveller.name}
                    </td>
                    <td className="px-3 py-2.5 text-neutral-900" data-id="element-856">
                      {traveller.dateOfBirth}
                    </td>
                    <td className="px-3 py-2.5 text-neutral-900" data-id="element-857">
                      {traveller.passportNo}
                    </td>
                    <td className="px-3 py-2.5 text-neutral-900" data-id="element-858">
                      {traveller.expiry}
                    </td>
                    <td className="px-3 py-2.5 text-neutral-900" data-id="element-859">
                      {traveller.nationality}
                    </td>
                    <td className="px-3 py-2.5 text-neutral-700" data-id="element-860">
                      {traveller.mealNotes || '—'}
                    </td>
                    <td className="px-3 py-2.5 text-neutral-900" data-id="element-861">
                      {traveller.visa || '—'}
                    </td>
                  </tr>)}
            </tbody>
          </table>
        </div>}
    </div>;
}